import * as React from "react";
import PropTypes from 'prop-types';

const SvgStoreIconFilled = props => {
  if (props.id !== "_svgstoreiconfilled") {
    throw new Error('SVG requires <Icon> component as a parent, e.g. <Icon><SvgLogo></Icon>');
  }

  return <svg viewBox="0 0 32 32" fill="none" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M3.2 24.8v1.6H8V16c0-1.28 1.067-1.6 1.6-1.6h12.8c1.28 0 1.6 1.067 1.6 1.6v10.4h4.8v-1.6h-1.6V7.2c0-1.28-1.067-1.6-1.6-1.6H6.4c-1.28 0-1.6 1.067-1.6 1.6v17.6H3.2zm7.2-15.2a.8.8 0 01.8-.8h9.6a.8.8 0 010 1.6h-9.6a.8.8 0 01-.8-.8zm0 6.4h4.8v10.4h-4.8V16zm6.4 0h4.8v10.4h-4.8V16z" fill="#202020" /></svg>;
};

SvgStoreIconFilled.displayName = "_svgstoreiconfilled";
SvgStoreIconFilled.propTypes = {
  id: PropTypes.string
};
SvgStoreIconFilled.defaultProps = {
  id: ''
};
export default SvgStoreIconFilled;